import React, {useEffect, useState} from 'react'
import propTypes from 'prop-types'
import {gql} from "apollo-boost";
import styled from 'styled-components';
import {Grid, Box} from '@material-ui/core';
import qs from 'qs';
import Router from 'next/router'
import {get} from 'lodash';

// static functions
import client from '../../src/graphql/client';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorRepaymentCalculatorModels from '../../src/data-restructure/pages/repayment-calculator/models';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

import {theme} from '../../src/themes/default-theme';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import CaravanCardSelect from '../../src/components/ui/CaravanCardSelect';
import Text from '../../src/components/typography';
import Cta from '../../src/components/ui/Cta';
import seoQuery from '../../src/graphql/queries/seo';


const CaravanCards = styled.div`
  max-width: 1200px;
  margin: 30px auto 25px;

  ${theme.breakpoints.up('md')} {
    margin: 60px auto 45px;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 115px auto 60px;
  }
`

const CaravanCardContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;

  ${theme.breakpoints.up('md')} {
    max-width: 335px;
  }
`

const Heading = styled.div`
  margin-bottom: 20px;
  ${theme.breakpoints.up('md')} {
    margin-bottom: 28px;
  }
`

const CtaContainer = styled.div `
  margin: 40px 0;

  a {
    min-width: 215px;
  }
`

const Model = (props) => {
  const [series, setSeries] = useState([]);

  const redirect = () => {
    const redirectUrl = '/repayments-calculator';
    // To prevent any slow routing on development
    process.env.NODE_ENV === 'development' ?
      window.location.href = redirectUrl
    :
    Router.push(redirectUrl)
  }

  useEffect(() => {
    if (process.env.SHOW_PRICING === false) {
      window.location.href = '/';
    }
    const qsData = qs.parse(window.location.search.replace('?', ''));
    if (!qsData || !qsData.range) {
      redirect()
    } else {
      const seriesState = props.series.filter(item => {
        return item.rangeIds.indexOf(parseInt(qsData.range)) !== -1
      })
      if (seriesState.length === 0) {
        redirect()
      } else {
        setSeries(seriesState);
      }
    }
  }, [])

  return (
  	<div>

      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          headingSize="large"
        />
      }

      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }

      {(series && series.length > 0) ?
        <CaravanCards>
          <Heading>
            <Text variant="h4" align="center" uppercase colour="charcoal">Choose your model</Text>
          </Heading>
          <Grid container direction={'row'} align={'left'}>
            {series.map(item => (
              <Grid item xs={12} md={6} lg={4} key={item.id}>
                <Box px={2}>
                  <CaravanCardContainer>
                    <CaravanCardSelect
                      {...item}
                    />
                  </CaravanCardContainer>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid container direction={'row'} align={'center'}>
            <Grid item xs={12}>
              <CtaContainer>
                <Cta href="/repayments-calculator" secondary outline inline>Go Back</Cta>
              </CtaContainer>
            </Grid>
          </Grid>
        </CaravanCards>
      :
        <CaravanCards>
          <Heading>
            <Text variant="h4" align="center" uppercase colour="charcoal">Redirecting...</Text>
          </Heading>
        </CaravanCards>
      }

    </div>
  )
}
  
Model.propTypes = {
}
  
Model.defaultProps = {
}

export async function getStaticProps() {
  const GET_REPAYMENTS_CALC_PAGE = gql`
    query GET_REPAYMENTS_CALC_PAGE($uri: String)  {
      pageBy(uri: $uri) {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
      }
      series(first: 1000) {
        edges {
          node {
            title
            id
            seriesId
            acf_domains {
              assignedDomains
            }
            acf_series {
              seriesHidePricing
              seriesRange {
                ... on Range {
                  rangeId
                }
              }
              seriesImage {
                ${respImgQuery}
              }
            }
          }
        }
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          title
          uri
          acf_floor_plan {
            modelHidePricing
            seriesSpec
            modelSeries {
              ... on Series {
                id
                seriesId
              }
            }
          }
        }
      }
    }
  `

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const pageProps = await client.query({
    query: GET_REPAYMENTS_CALC_PAGE,
    variables: {
      uri: `repayments-calculator?${countryCode}`
    }
  });

  const assignedDomains = get(pageProps, 'data.pageBy.acf_domains.assignedDomains', []); 

  const breadcrumbs = await refactorBreadcrumbsData('/repayments-calculator/model', assignedDomains);

  const data = refactorRepaymentCalculatorModels(pageProps)

  const pageBy = pageProps ? get(pageProps, 'data.pageBy', null) : null;

  return {
    props: {
      meta: {
        title: pageBy ? pageBy.title : null,
        seo: pageBy ? pageBy.seo : null,
        noIndex: true
      },
      breadcrumbs,
      ...data
    }
  }
}
  
export default Model